import React from 'react';
import { HomeContainer } from './Home.styled';
import Header from '../Header/Header.jsx';
import Hero from '../Hero/Hero.jsx';
import MarqueeTextComponent from '../MarqueeText/MarqueeTextComponent.jsx';
import DiscoverSection from '../DiscoverSection/DiscoverSection.jsx';
import Categories from '../Categories/Categories.jsx';
import Footer from '../Footer/Footer.jsx';

const Home = () => {
  return (
    <HomeContainer
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.5 }}
    >
      <Header />
      <Hero />
      <MarqueeTextComponent />
      <DiscoverSection />
      <Categories />
      <Footer />
    </HomeContainer>
  );
};

export default Home;
